"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var DetailsModel = function DetailsModel(json, lang, name) {
  var data = [];
  data.all = {
    title: '',
    cmps: []
  };
  data.id = json.at_maker_id ? json.at_maker_id : '';
  if (json.enterprise_cmp_collections.length > 0) {
    for (var i = 0; i < json.enterprise_cmp_collections.length; i++) {
      var cmp_collection = json.enterprise_cmp_collections[i];
      var collection_title = cmp_collection.cmp_collection.name ? cmp_collection.cmp_collection.name : "CMP's";
      var items = [];
      for (var j = 0; j < cmp_collection.cmp_collection.cmps.length; j++) {
        var item = cmp_collection.cmp_collection.cmps[j];
        var cmp = {
          url: item.cat_network_url ? item.cat_network_url : '',
          thumbnail: item.thumbnail ? item.thumbnail : '',
          title: item.name ? item.name : '',
          type: item.cmp_type ? item.cmp_type.toLowerCase() : '',
          from: item.valid_start ? item.valid_start.substring(0, 10) : '-',
          to: item.valid_end ? item.valid_end.substring(0, 10) : '',
          weight: item.score ? item.score : ''
        };
        // items.push(cmp)

        if (item.visible_end && item.visible_start) {
          var dateString = item.visible_start;
          var reggie = /(\d{2})-(\d{2})-(\d{4}) (\d{2}):(\d{2})/;
          var dateArray = reggie.exec(dateString);
          var visible_start = new Date(+dateArray[3], +dateArray[2] - 1, +dateArray[1], +dateArray[4], +dateArray[5]);
          visible_start.setHours(visible_start.getHours() + 2);
          var dateString = item.visible_end;
          var reggie = /(\d{2})-(\d{2})-(\d{4}) (\d{2}):(\d{2})/;
          var dateArray = reggie.exec(dateString);
          var visible_end = new Date(+dateArray[3], +dateArray[2] - 1, +dateArray[1], +dateArray[4], +dateArray[5]);
          visible_end.setHours(visible_end.getHours() + 2);
          var today = new Date();
          if (visible_start.getTime() < today.getTime() && visible_end.getTime() > today.getTime()) {
            items.push(cmp);
            data.all.cmps.push(cmp);
          }
        } else {
          items.push(cmp);
          data.all.cmps.push(cmp);
        }

        // if (item.visible_start)
      }

      data.push({
        title: collection_title,
        cmps: items
      });
    }
  }
  if (json.establishment_cmp_collections.length > 0) {
    for (var _i = 0; _i < json.establishment_cmp_collections.length; _i++) {
      var _cmp_collection = json.establishment_cmp_collections[_i];
      var _collection_title = _cmp_collection.cmp_collection.name ? _cmp_collection.cmp_collection.name : "CMP's";
      var _items = [];
      for (var _j = 0; _j < _cmp_collection.cmp_collection.cmps.length; _j++) {
        var _item = _cmp_collection.cmp_collection.cmps[_j];
        var _cmp = {
          url: _item.cat_network_url ? _item.cat_network_url : '',
          thumbnail: _item.thumbnail ? _item.thumbnail : '',
          title: _item.name ? _item.name : '',
          type: _item.cmp_type ? _item.cmp_type.toLowerCase() : '',
          from: _item.valid_start ? _item.valid_start.substring(0, 10) : '-',
          to: _item.valid_end ? _item.valid_end.substring(0, 10) : '',
          weight: _item.score ? _item.score : ''
        };
        // items.push(cmp)

        if (_item.visible_end && _item.visible_start) {
          var dateString = _item.visible_start;
          var reggie = /(\d{2})-(\d{2})-(\d{4}) (\d{2}):(\d{2})/;
          var dateArray = reggie.exec(dateString);
          var visible_start = new Date(+dateArray[3], +dateArray[2] - 1, +dateArray[1], +dateArray[4], +dateArray[5]);
          visible_start.setHours(visible_start.getHours() + 2);
          var dateString = _item.visible_end;
          var reggie = /(\d{2})-(\d{2})-(\d{4}) (\d{2}):(\d{2})/;
          var dateArray = reggie.exec(dateString);
          var visible_end = new Date(+dateArray[3], +dateArray[2] - 1, +dateArray[1], +dateArray[4], +dateArray[5]);
          visible_end.setHours(visible_end.getHours() + 2);
          var _today = new Date();
          if (visible_start.getTime() < _today.getTime() && visible_end.getTime() > _today.getTime()) {
            _items.push(_cmp);
            data.all.cmps.push(_cmp);
          }
        } else {
          _items.push(_cmp);
          data.all.cmps.push(_cmp);
        }

        // if (item.visible_start)
      }

      data.push({
        title: _collection_title,
        cmps: _items
      });
    }
  }
  if (json.group_cmp_collections.length > 0) {
    for (var _i2 = 0; _i2 < json.group_cmp_collections.length; _i2++) {
      var _cmp_collection2 = json.group_cmp_collections[_i2];
      var _collection_title2 = _cmp_collection2.cmp_collection.name ? _cmp_collection2.cmp_collection.name : "CMP's";
      var _items2 = [];
      for (var _j2 = 0; _j2 < _cmp_collection2.cmp_collection.cmps.length; _j2++) {
        var _item2 = _cmp_collection2.cmp_collection.cmps[_j2];
        var _cmp2 = {
          url: _item2.cat_network_url ? _item2.cat_network_url : '',
          thumbnail: _item2.thumbnail ? _item2.thumbnail : '',
          title: _item2.name ? _item2.name : '',
          type: _item2.cmp_type ? _item2.cmp_type.toLowerCase() : '',
          from: _item2.valid_start ? _item2.valid_start.substring(0, 10) : '-',
          to: _item2.valid_end ? _item2.valid_end.substring(0, 10) : '',
          weight: _item2.score ? _item2.score : ''
        };
        // items.push(cmp)

        if (_item2.visible_end && _item2.visible_start) {
          var dateString = _item2.visible_start;
          var reggie = /(\d{2})-(\d{2})-(\d{4}) (\d{2}):(\d{2})/;
          var dateArray = reggie.exec(dateString);
          var visible_start = new Date(+dateArray[3], +dateArray[2] - 1, +dateArray[1], +dateArray[4], +dateArray[5]);
          visible_start.setHours(visible_start.getHours() + 2);
          var dateString = _item2.visible_end;
          var reggie = /(\d{2})-(\d{2})-(\d{4}) (\d{2}):(\d{2})/;
          var dateArray = reggie.exec(dateString);
          var visible_end = new Date(+dateArray[3], +dateArray[2] - 1, +dateArray[1], +dateArray[4], +dateArray[5]);
          visible_end.setHours(visible_end.getHours() + 2);
          var _today2 = new Date();
          if (visible_start.getTime() < _today2.getTime() && visible_end.getTime() > _today2.getTime()) {
            _items2.push(_cmp2);
            data.all.cmps.push(_cmp2);
          }
        } else {
          _items2.push(_cmp2);
          data.all.cmps.push(_cmp2);
        }

        // if (item.visible_start)
      }

      data.push({
        title: _collection_title2,
        cmps: _items2
      });
    }
  }
  return data;
};
var _default = DetailsModel;
exports["default"] = _default;